export const timeDelay = (ms): Promise<any> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
